import React from "react";
import { Plural } from "@lingui/macro";
import { Badge, BodyLarge, SiteOutline } from "@conserveit/blocks";
import { GroupHeadingProps } from "../../utils";
import {
  Bar,
  Left,
  Right,
  IconWrapper,
  TodayCountWrapper,
  SubduedBodyLarge,
} from "../GroupHeading.styles";

const SiteGroupHeading: React.FunctionComponent<GroupHeadingProps> = ({
  instance,
  insightsCount,
  insightsCountToday,
  equipsCount,
  unassociatedEquipsCount,
}) => {
  return (
    <Bar>
      <Left>
        <IconWrapper>
          <SiteOutline />
        </IconWrapper>
        <BodyLarge as="div">
          {instance.site.label}{" "}
          <SubduedBodyLarge as="span">({insightsCount})</SubduedBodyLarge>
          <TodayCountWrapper>
            <Plural
              value={equipsCount}
              one={`${unassociatedEquipsCount} of ${equipsCount} Equip Unassociated`}
              other={`${unassociatedEquipsCount} of ${equipsCount} Equips Unassociated`}
            />
          </TodayCountWrapper>
        </BodyLarge>
      </Left>
      <Right>
        {insightsCountToday > 0 && <Badge>{insightsCountToday} new</Badge>}
      </Right>
    </Bar>
  );
};

export default SiteGroupHeading;
